import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  carusel_container: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "74px",
  },
  thumb: {
    borderRadius: 4,
    backgroundColor: "#F3F3F3",
    width: "14px",
  },
}));

export default useStyles;
